export default __webpack_public_path__ + "static/media/video.254ff1cd.mp4";